export const months = [
  { key: '01', value: 'January' },
  { key: '02', value: 'February' },
  { key: '03', value: 'March' },
  { key: '04', value: 'April' },
  { key: '05', value: 'May' },
  { key: '06', value: 'June' },
  { key: '07', value: 'July' },
  { key: '08', value: 'August' },
  { key: '09', value: 'September' },
  { key: '10', value: 'October' },
  { key: '11', value: 'November' },
  { key: '12', value: 'December' },
];

export const monthsAbbr = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'June' },
  { key: '07', value: 'July' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sept' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' },
];

export const monthKey = (monthValue: string | null | undefined): string => {
  if (!monthValue) return '00';
  const month = months.find((m) => m.value === monthValue);
  return month ? month.key : '00';
};
